import { render, staticRenderFns } from "./PostComposer.vue?vue&type=template&id=1080ac8e&scoped=true&"
import script from "./PostComposer.vue?vue&type=script&lang=js&"
export * from "./PostComposer.vue?vue&type=script&lang=js&"
import style0 from "./PostComposer.vue?vue&type=style&index=0&id=1080ac8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1080ac8e",
  null
  
)

export default component.exports